import React from 'react';
import { useField } from '../FormContext';
import InstructionalTextFieldView from '../view/InstructionalTextFieldView';

const InstructionalTextFieldEngine = ({ internalId, title = '', ...props }) => {
  const viewProps = { title, ...props };
  useField(internalId, () => '');

  return <InstructionalTextFieldView {...viewProps} />;
};

export default InstructionalTextFieldEngine;
